import { Collapse, notification } from 'antd';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  getKeyByValue,
  monthsInYear,
  UserTypeDict,
} from '../../../../utils/settings';
import { getMonthlySaleTotalReportBuy } from '../../action/util_action';
import OrderBookingTable from '../orders/OrderBookingTable';

const { Panel } = Collapse;

const UserReportMontlyCard = ({ item = {} }) => {
  const [monthlyTrans, setMonthlyTrans] = useState([]);

  const { loginUser } = useSelector((state) => {
    return {
      loginUser: state.loginReducer.loginUser,
    };
  });

  const getMonthlyAlalytics = async (year, month) => {
    // if (monthlyTrans.length > 0) return;
    const { error, data, message } = await getMonthlySaleTotalReportBuy({
      year,
      month,
    });

    if (!error) {
      if (
        loginUser.company_details.company_type === UserTypeDict['RETAILER'] ||
        loginUser.company_details.company_type === UserTypeDict['ASSOCIATE']
      ) {
        setMonthlyTrans(data.retailer_buy ? data.retailer_buy : []);
      } else {
        setMonthlyTrans(data.distributor_buy ? data.distributor_buy : []);
      }
    } else notification.error({ message: message });
  };

  useEffect(() => {
    getMonthlyAlalytics(item?.year, item?.month);
  }, []);

  const tableData = {
    rows: ['Date', 'QTY'],
    tableData: monthlyTrans.map((item) => [
      `${getKeyByValue(monthsInYear, Number(item.month))}, ${item.date}`,
      Number(item.sells_quantity.quantity_in_metric_ton).toFixed(3),
    ]),
    onRowClick: (index) => {},
  };

  const tableDataCompany = {
    rows: ['Company Name', 'QTY'],
    tableData: [1].map(() => [
      item.buy_or_sell_to_company_name,
      Number(item.sells_quantity.quantity_in_metric_ton).toFixed(3),
    ]),
    onRowClick: (index) => {},
  };

  return (
    <Collapse
      collapsible='header'
      bordered={false}
    >
      <Panel
        header={
          <h4>{`Month: ${getKeyByValue(monthsInYear, Number(item.month))}, ${
            item.year
          }`}</h4>
        }
        key={`Month: ${getKeyByValue(monthsInYear, Number(item.month))}, ${
          item.year
        } ${item.sells_quantity.quantity_in_metric_ton} ${item.company_id}`}
      >
        <OrderBookingTable data={tableDataCompany} />
        <OrderBookingTable data={tableData} />
      </Panel>
    </Collapse>
  );
};

export default UserReportMontlyCard;
